export const flatten = (obj, path = [], sep = '.') =>
    Object.keys(obj).reduce(
        (memo, prop) =>
            Object.assign(
                {},
                memo,
                typeof obj[prop] === 'object' && obj[prop] !== null
                    ? flatten(obj[prop], path.concat([prop]), sep)
                    : { [path.concat([prop]).join(sep)]: obj[prop] }
            ),
        {}
    );
